// AUTO-GENERATED by component-codegen
// DO NOT EDIT — regenerated on build start, HMR, and `bun run gen:components`.
//
// `Components.X` is a typed token; use `go.getComponent(Components.X)`.

import type { ComponentToken } from './scripting/IEngineContext';
import { ct } from './ComponentTable';

import type { AmbientLight2D } from './components/AmbientLight2D.component';
import type { AudioListener } from './components/AudioListener.component';
import type { AudioSource } from './components/AudioSource.component';
import type { BoxCollider2D } from './components/BoxCollider2D.component';
import type { BuoyancyZone2D } from './components/BuoyancyZone2D.component';
import type { Camera2D } from './components/Camera2D.component';
import type { CameraRig } from './components/CameraRig.component';
import type { CapsuleCollider2D } from './components/CapsuleCollider2D.component';
import type { CircleCollider2D } from './components/CircleCollider2D.component';
import type { ConvexCollider2D } from './components/ConvexCollider2D.component';
import type { DirectionalLight2D } from './components/DirectionalLight2D.component';
import type { GravityZone2D } from './components/GravityZone2D.component';
import type { PointLight2D } from './components/PointLight2D.component';
import type { PolygonCollider2D } from './components/PolygonCollider2D.component';
import type { RigidBody2D } from './components/RigidBody2D.component';
import type { Script } from './components/Script.component';
import type { Spline2D } from './components/Spline2D.component';
import type { SpotLight2D } from './components/SpotLight2D.component';
import type { SpriteRenderer } from './components/SpriteRenderer.component';
import type { SurfaceEffector2D } from './components/SurfaceEffector2D.component';
import type { TargetGroup } from './components/TargetGroup.component';
import type { Text } from './components/Text.component';
import type { Transform as TransformComponent } from './components/Transform.component';
import type { UICanvas } from './components/UICanvas.component';
import type { VFXEmitter } from './components/VFXEmitter.component';
import type { WindZone2D } from './components/WindZone2D.component';
import type { InputReceiver } from '../../input/src/InputReceiverComponent';

/** Typed component tokens — reflection-free `GetComponent<T>()`. */
export const Components = {
  AmbientLight2D: ct<AmbientLight2D>(0, 'core.AmbientLight2D'),
  AudioListener: ct<AudioListener>(1, 'core.AudioListener'),
  AudioSource: ct<AudioSource>(2, 'core.AudioSource'),
  BoxCollider2D: ct<BoxCollider2D>(3, 'core.BoxCollider2D'),
  BuoyancyZone2D: ct<BuoyancyZone2D>(4, 'core.BuoyancyZone2D'),
  Camera2D: ct<Camera2D>(5, 'core.Camera2D'),
  CameraRig: ct<CameraRig>(6, 'core.CameraRig'),
  CapsuleCollider2D: ct<CapsuleCollider2D>(7, 'core.CapsuleCollider2D'),
  CircleCollider2D: ct<CircleCollider2D>(8, 'core.CircleCollider2D'),
  ConvexCollider2D: ct<ConvexCollider2D>(9, 'core.ConvexCollider2D'),
  DirectionalLight2D: ct<DirectionalLight2D>(10, 'core.DirectionalLight2D'),
  GravityZone2D: ct<GravityZone2D>(11, 'core.GravityZone2D'),
  PointLight2D: ct<PointLight2D>(12, 'core.PointLight2D'),
  PolygonCollider2D: ct<PolygonCollider2D>(13, 'core.PolygonCollider2D'),
  RigidBody2D: ct<RigidBody2D>(14, 'core.RigidBody2D'),
  Script: ct<Script>(15, 'core.Script'),
  Spline2D: ct<Spline2D>(16, 'core.Spline2D'),
  SpotLight2D: ct<SpotLight2D>(17, 'core.SpotLight2D'),
  SpriteRenderer: ct<SpriteRenderer>(18, 'core.SpriteRenderer'),
  SurfaceEffector2D: ct<SurfaceEffector2D>(19, 'core.SurfaceEffector2D'),
  TargetGroup: ct<TargetGroup>(20, 'core.TargetGroup'),
  Text: ct<Text>(21, 'core.Text'),
  Transform: ct<TransformComponent>(22, 'core.Transform'),
  UICanvas: ct<UICanvas>(23, 'core.UICanvas'),
  VFXEmitter: ct<VFXEmitter>(24, 'core.VFXEmitter'),
  WindZone2D: ct<WindZone2D>(25, 'core.WindZone2D'),
  InputReceiver: ct<InputReceiver>(26, 'input.InputReceiver'),
} as const;

/** Total registered component types. */
export const COMPONENT_COUNT = 27;
